import { render } from "./PanelLayout.vue?vue&type=template&id=6b782cb0"
import script from "./PanelLayout.vue?vue&type=script&lang=js"
export * from "./PanelLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__